import { useCallback } from 'react'
import { useSetRecoilState } from 'recoil'
import { usersState } from '../states/users-state'

import axios from 'axios'
import { getHeaders } from '../utils/get-headers'
import { getServerHost } from '../utils/get-server-host'

export const fetchUser = async ({ userId }) => {
  try {
    const result = await axios.get(getServerHost(`user/${userId}`), { headers: getHeaders() })

    if (result.status === 200) {
      return result.data.user
    }
  } catch (error) {
    console.log(error)
  }
}

export const useFetchUser = ({ userId }) => {
  const setUsers = useSetRecoilState(usersState)

  return useCallback(async () => {
    const user = await fetchUser({ userId })

    // TODO: Guard
    if (user) {
      setUsers((prevState) => [...prevState, user])
    }
  }, [userId])
}